import { useEffect } from 'react';
import type { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { Col, Row, theme, Typography } from 'antd';
import { PosInput } from 'pos-client/components/shared/Form/PosInput.tsx';
import { trpc } from 'pos-client/utils/trpc.ts';
import type {
  LocationCreateEditModel,
  LocationModel,
} from 'pos-shared/models/locationSchema.ts';

export const LocationLoginTab = ({
  location,
  locationForm,
}: {
  location?: LocationModel;
  locationForm: UseFormReturn<LocationCreateEditModel>;
}) => {
  const { t } = useTranslation();
  const { token } = theme.useToken();
  const { control, getValues, setValue } = locationForm;

  const { data: epicoreCredentials, isLoading: isLoadingCredentials } =
    trpc.serviceLocation.getEpicoreCredentials.useQuery(
      { id: location?.id as string },
      {
        enabled: !!location?.id,
      }
    );

  useEffect(() => {
    if (epicoreCredentials) {
      const { epicorLogin } = getValues();

      if (epicoreCredentials !== epicorLogin && !!epicoreCredentials) {
        setValue('epicorLogin', {
          username: epicoreCredentials?.username ?? '',
          password: epicoreCredentials?.password ?? '',
        });
      }
    }
  }, [epicoreCredentials, isLoadingCredentials]);

  return (
    <>
      <Row>
        <Typography.Title level={4}>
          {t('clients.epicor.epicorUserLoginDetails')}
        </Typography.Title>
      </Row>
      <Row style={{ marginBottom: token.margin, width: '80%' }}>
        <Typography.Text>{t('clients.epicor.epicorLoginHint')}</Typography.Text>
      </Row>
      <Row gutter={token.margin} style={{ marginBottom: token.marginXL }}>
        <Col span="8">
          <PosInput
            control={control}
            name="epicorLogin.username"
            noMarginOnValid
            aria-label={t('users.username')}
            placeholder={t('users.username')}
            disabled={isLoadingCredentials}
          />
        </Col>
        <Col span="8">
          <PosInput
            control={control}
            name="epicorLogin.password"
            type="password"
            aria-label={t('users.password.password')}
            placeholder={t('users.password.password')}
            disabled={isLoadingCredentials}
            noMarginOnValid
          />
        </Col>
      </Row>
    </>
  );
};
